module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.val
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560bdb22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/TextNumber.vue
// module id = 458
// module chunks = 1